<template>
    <div class="content">
        <table border="1" cellspacing="0">
            <colgroup>
                <col style="width:9%">
                <col style="width:12%">
                <col style="width:16%">
                <col style="width:14%">
                <col style="width:13%">
                <col style="width:18%">
                <col style="width:18%">
            </colgroup>
            <tr>
                <td colspan="7" class="table-title"><b>第三方信息共享清单</b></td>
            </tr>
            <tr>
                <td><b>功能类型</b></td>
                <td><b>第三方名称</b></td>
                <td><b>使用目的</b></td>
                <td><b>使用场景</b></td>
                <td><b>共享方式</b></td>
                <td><b>个人信息类型</b></td>
                <td><b>第三方隐私政策链接</b></td>
            </tr>
            <tr>
                <td rowspan="2">支付</td>
                <td>微信支付</td>
                <td>帮助用户在应用内使用微信支付完成会员购买</td>
                <td>用户需要支付费用时</td>
                <td>微信支付SDK本地采集</td>
                <td><b><i>设备版本、系统版本、生成ID、iccid、bssid、MAC地址、IMSI、IMEI、对账信息</i></b></td>
                <td class="link"><a href="https://pay.weixin.qq.com/index.php/public/apply_sign/protocol_v2" target="_blank" rel="noopener">https://pay.weixin.qq.com/index.php/public/apply_sign/protocol_v2</a></td>
            </tr>
            <tr>
                <td>支付宝</td>
                <td>帮助用户在应用内使用支付宝支付完成会员购买</td>
                <td>用户需要支付费用时</td>
                <td>支付宝SDK本地采集</td>
                <td><b><i>设备版本、系统版本、生成ID、iccid、bssid、MAC地址、IMSI、IMEI、对账信息、传感器、设备序列号、ip地址、运营商信息</i></b></td>
                <td class="link"><a href="https://render.alipay.com/p/yuyan/180020010001196791/preview.html?agreementId=AG00000174" target="_blank" rel="noopener">https://render.alipay.com/p/yuyan/180020010001196791/preview.html?agreementId=AG00000174</a></td>
            </tr>
            <tr>
                <td rowspan="2">工具</td>
                <td>Cocos2D-X SDK</td>
                <td>帮助用户使用应用时确认设备稳定</td>
                <td>仅在启动APP、初始化时进行收集</td>
                <td>SDK本地采集</td>
                <td><b><i>设备传感器</i></b></td>
                <td class="link"><a href="https://download.cocos.com/CocosUdc/agreement/Cocos_Privacy_Policy_cn_20200904.html" target="_blank" rel="noopener">https://download.cocos.com/CocosUdc/agreement/Cocos_Privacy_Policy_cn_20200904.html</a></td>
            </tr>
            <tr>
                <td>Chromium SDK</td>
                <td>调用浏览器功能，展示软件的常见问答信息</td>
                <td>用户打开帮助页面等调用浏览器时</td>
                <td>SDK本地采集</td>
                <td><b><i>监听剪切板、获取当前已连接上的wifi的信息、获取SSID信息、获取BSSID信息</i></b></td>
                <td class="link"><a href="https://www.chromium.org/Home/chromium-privacy/" target="_blank" rel="noopener">https://www.chromium.org/Home/chromium-privacy/</a></td>
            </tr>
        </table>
    </div>
</template>
<script>

export default {
  name: 'privacyThirdParty',
}
</script>
<style scoped>
    .content {
        padding: 30px;
        line-height: 2em;
        overflow-x: hidden;
    }
    table {
        width: 100%;
        max-width: 100%;
        table-layout: fixed;
        border-collapse: collapse;
    }
    td {
        padding: 6px;
        vertical-align: top;
        overflow-wrap: anywhere;
    }
    .table-title {
        text-align: center;
    }
    .link a {
        overflow-wrap: anywhere;
    }

    @media (max-width: 720px) {
        .content {
            padding: 10px;
            line-height: 1.5em;
            font-size: 12px;
        }
        td {
            padding: 3px;
        }
    }
</style>
